import './LoadingOverlay.css'

/** Full-screen busy state — the legacy `#loading` curtain. */
export default function LoadingOverlay({ open, label }) {
  if (!open) return null

  return (
    <div className="loading-overlay" data-testid="loading-overlay" role="alert" aria-busy="true" aria-live="assertive">
      <div className="loading-overlay__inner">
        <div className="loading-overlay__spinner" aria-hidden="true" />
        <h1 className="loading-overlay__label">{label}</h1>
        <div className="loading-overlay__dots" aria-hidden="true">
          <span />
          <span />
          <span />
        </div>
      </div>
    </div>
  )
}
